import { FC, useState } from 'react'
import PrintIcon from '@mui/icons-material/Print'
import { Button, CircularProgress } from '@mui/material'

import { ObjectDataRecord } from '@types'

import { useExecutePrintFormCommand } from '../hooks/useExecutePrintFormCommand'
import { PrintFormConfig } from '../types'

import { PrintTrigger } from './PrintTrigger'

type PrintFormButtonProps = {
  config: PrintFormConfig
  /** Блокировка снаружи (например, форма не заполнена до конца). */
  isDisabled?: boolean
  label?: string
}

export const PrintFormButton: FC<PrintFormButtonProps> = ({
  config,
  isDisabled = false,
  label = 'Печать',
}) => {
  const { loadRecords, isLoading, error } = useExecutePrintFormCommand()
  const [htmlRecords, setHtmlRecords] = useState<ObjectDataRecord[] | null>(null)

  const loadData = async (): Promise<ObjectDataRecord[] | null> => {
    const data = await loadRecords(config)

    if (!data || data.length === 0) {
      return null
    }

    return data
  }

  const handleHtmlPrint = async () => {
    const data = await loadData()
    if (!data) return

    setHtmlRecords(data)
  }

  const handlePrintDone = () => setHtmlRecords(null)

  return (
    <>
      <Button
        disabled={isDisabled || isLoading}
        startIcon={isLoading ? <CircularProgress size={16} /> : <PrintIcon />}
        variant='outlined'
        onClick={handleHtmlPrint}
      >
        {label}
      </Button>
      {error && <span style={{ marginLeft: 8, color: '#d32f2f' }}>{error}</span>}

      {htmlRecords && (
        <PrintTrigger config={config} records={htmlRecords} onDone={handlePrintDone} />
      )}
    </>
  )
}
